import React, { Fragment, useState } from "react";
import { Row, Col, Button } from 'react-bootstrap';
import '../../../../../../../styles/diario.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleMinus } from '@fortawesome/free-solid-svg-icons'

const Local = (props) => {
    const id = props.local.local;
    const profissional = props.profissional
    const [local, setLocal] = useState(props.local.local)
    const [horarios, setHorarios] = useState(props.local.horarios)
    const [dia, setDia] = useState(props.local.dia)
    const [error, setError] = useState("")

    const deletar = async (profissional, id) => {
        props.deletar(profissional, id)
        await props.fetchProfissional(profissional)
    }


    return (
        <Fragment>
            <Row xs={9} lg={9}>
                <Col xs={3} lg={5}>
                    <p>{local}</p>
                </Col>
                <Col xs={3} lg={2}>
                    <p>{dia}</p>
                </Col>
                <Col xs={2}>
                    <p>{horarios}</p>
                </Col>
                <Col xs={1}>
                    <Button type='button' onClick={() => deletar(profissional, props.local._id)} variant='danger'>
                        <FontAwesomeIcon icon={faCircleMinus} />
                    </Button>
                </Col>
            </Row>
            <br />
        </Fragment >)
}

export default Local;